/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDepartments } from 'app/entities/department/department.reducer';
import { getEntities as getDiaglabBills } from 'app/entities/diaglab-bill/diaglab-bill.reducer';
import { getEntities as getTumors } from 'app/entities/tumor/tumor.reducer';
import { createEntity, getEntity, reset, updateEntity } from './tumor-source.reducer';

export const TumorSourceUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const departments = useAppSelector(state => state.department.entities);
  const diaglabBills = useAppSelector(state => state.diaglabBill.entities);
  const tumors = useAppSelector(state => state.tumor.entities);
  const tumorSourceEntity = useAppSelector(state => state.tumorSource.entity);
  const loading = useAppSelector(state => state.tumorSource.loading);
  const updating = useAppSelector(state => state.tumorSource.updating);
  const updateSuccess = useAppSelector(state => state.tumorSource.updateSuccess);

  const handleClose = () => {
    navigate(`/tumor-source${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDepartments({}));
    dispatch(getDiaglabBills({}));
    dispatch(getTumors({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.createDate !== undefined && typeof values.createDate !== 'number') {
      values.createDate = Number(values.createDate);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tumorSourceEntity,
      ...values,
      unit: departments.find(it => it.id.toString() === values.unit?.toString()),
      test: diaglabBills.find(it => it.id.toString() === values.test?.toString()),
      tumor: tumors.find(it => it.id.toString() === values.tumor?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...tumorSourceEntity,
          unit: tumorSourceEntity?.unit?.id,
          test: tumorSourceEntity?.test?.id,
          tumor: tumorSourceEntity?.tumor?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.tumorSource.home.createOrEditLabel" data-cy="TumorSourceCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.tumorSource.home.createOrEditLabel">Create or edit a TumorSource</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tumor-source-id"
                  label={translate('tinyMedicRestApp.tumorSource.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorSource.entityId')}
                id="tumor-source-entityId"
                name="entityId"
                data-cy="entityId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorSource.entityType')}
                id="tumor-source-entityType"
                name="entityType"
                data-cy="entityType"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorSource.entityName')}
                id="tumor-source-entityName"
                name="entityName"
                data-cy="entityName"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorSource.caseNumber')}
                id="tumor-source-caseNumber"
                name="caseNumber"
                data-cy="caseNumber"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorSource.caseType')}
                id="tumor-source-caseType"
                name="caseType"
                data-cy="caseType"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorSource.createdBy')}
                id="tumor-source-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorSource.createDate')}
                id="tumor-source-createDate"
                name="createDate"
                data-cy="createDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorSource.lastUpdated')}
                id="tumor-source-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorSource.lastModifiedBy')}
                id="tumor-source-lastModifiedBy"
                name="lastModifiedBy"
                data-cy="lastModifiedBy"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorSource.active')}
                id="tumor-source-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorSource.cursor')}
                id="tumor-source-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorSource.microSec')}
                id="tumor-source-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorSource.timestampEntry')}
                id="tumor-source-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="tumor-source-unit"
                name="unit"
                data-cy="unit"
                label={translate('tinyMedicRestApp.tumorSource.unit')}
                type="select"
              >
                <option value="" key="0" />
                {departments
                  ? departments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-source-test"
                name="test"
                data-cy="test"
                label={translate('tinyMedicRestApp.tumorSource.test')}
                type="select"
              >
                <option value="" key="0" />
                {diaglabBills
                  ? diaglabBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-source-tumor"
                name="tumor"
                data-cy="tumor"
                label={translate('tinyMedicRestApp.tumorSource.tumor')}
                type="select"
              >
                <option value="" key="0" />
                {tumors
                  ? tumors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tumor-source" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TumorSourceUpdate;
